"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useServiceWorker = void 0;
const react_1 = require("react");
const useServiceWorker = ({ enable }) => {
    const register = (0, react_1.useCallback)(async (worker) => {
        const result = { error: null, registration: null };
        if (enable && 'serviceWorker' in navigator) {
            try {
                result.registration = await navigator.serviceWorker.register(worker);
            }
            catch (error) {
                result.error = error;
            }
        }
        else {
            result.error = new ReferenceError('navigator does not support service workers');
        }
        return result;
    }, [enable]);
    return (0, react_1.useMemo)(() => ({ register }), [register]);
};
exports.useServiceWorker = useServiceWorker;
//# sourceMappingURL=useServiceWorker.js.map